import React, { useContext, useEffect, useState } from 'react'
import { apiDelete, apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { AiFillDelete, AiFillEdit, AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../utils/helpers'
import { Link, NavLink } from 'react-router-dom'

const ProjectTable = ({
  paginationObj,
  sort,
  setSort,
  list,
  fetchProjects,
  manager
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)

const [data, setData] = useState(list)

useEffect(()=>{
  setData(list)
},[list])

  const handelDelete = async item => {
    try {
      const path = apiPath.discoverCommunities + '/' + item?._id
      const result = await apiDelete(path)
      if (result?.status === 200) {
        // getAllFAQ({ deletePage: 1 })
        const path = apiPath.discoverCommunities
        const result = await apiGet(path, {page: 1,
          pageCount: 1,
          pageRangeDisplayed: 10})
        const response = result?.data?.results;
        setData(response?.docs)
      }
    } catch (error) {
      console.log('error in get all FAQs list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
              >
                <div className='flex'>
                  <span>{t('COMMUNITY')} </span>
                </div>
              </th>
            
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
              >
                <div className='flex'>
                  <span>{t('O_SUBTITLE')} </span>
                </div>
              </th>
             
              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_CREATED_AT')}
              </th>
              
              {/* <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
              >
                <div className='flex'>
                  <span>{t('DESCRIPTION_SECOND')} </span>
             
                </div>
              </th>
             
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
              >
                <div className='flex'>
                  <span>{t('DESCRIPTION_THIRD')} </span>
             
                </div>
              </th> */}
           
              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>
                    {item.communityTitle ? item.communityTitle : 'N/A'}
                  </td>
               
                  <td className='py-2 px-2 border-r text-DarkBlue'>
                  {item.subTitle ? item.subTitle : 'N/A'}               
                  </td>
                  <td className='py-2 px-2 border-r text-DarkBlue'>
                  {helper.dateFormat(item?.createdAt)}
                  {/* {item.createdAt ? item.createdAt : 'N/A'}                */}
                  </td>
                  {/* <td className='py-2 px-2 border-r' dangerouslySetInnerHTML={{ __html: item?.description?.slice(0, 50) }}></td>
                  <td className='py-2 px-2 border-r' dangerouslySetInnerHTML={{ __html: item?.description2?.slice(0, 50) }}></td>             
                  <td className='py-2 px-2 border-r' dangerouslySetInnerHTML={{ __html: item?.description3?.slice(0, 50) }}></td>  */}
                  
                  
                  <td className='py-4 px-6 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                          <NavLink to='/community-detail' state={{ item }}>
                            <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />
                          </NavLink>
                        </li>
                        {(manager?.add || user?.role === 'admin') && (
                          <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                            <Link
                              title={t('O_EDIT_PROJECT')}
                              to={`/edit-community`}
                              state={{ item }}
                            >
                              <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                            </Link>
                          </li>
                        )}
                         {(manager?.delete || user?.role === 'admin') && ( <li
                              onClick={e =>
                                helper.alertFunction(
                                  `Are you sure want to delete ${item.communityTitle}?`,
                                  item,
                                  handelDelete,
                                  true
                                )
                              }
                              // onClick={() => handelDelete(item)}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                            >
                              <button title={t('O_DELETE')}>
                                <AiFillDelete className='w-5 h-5 text-red-600' />
                              </button>
                            </li>
                         )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(list) && (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ProjectTable
